exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-wrap{width:100%;height:100%;overflow:hidden;display:flex;justify-content:center;align-items:center}.login-box{width:355px;border-radius:5px;padding:40px 40px 0;opacity:0.9}.login-box .login-btn{width:100%;background-color:#279ce0;color:#fff;border:1px solid #279ce0}.login-box img{width:100%;margin-bottom:20px}.ant-checkbox-wrapper{color:#fff}.ant-input{opacity:0.7}.ant-checkbox-checked{background-color:#0f1e43}.wrap .header .logo-box img{height:50% !important}.ant-checkbox-checked .ant-checkbox-inner{background-color:#004f88;border-color:#004f88}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Login/style.scss
// module id = 643
// module chunks = 2